import { FormCard } from '@/components/common/FormCard';
import { PageSection } from '@/components/common/PageSection';
import { ContactDetailsCard } from '@/pages/Contact/components/ContactDetailsCard';
import { ContactForm } from '@/pages/Contact/components/ContactForm';
import { ProjectPromptCard } from '@/pages/Contact/components/ProjectPromptCard';

const TitleId = 'contact-form-title';

export function ContactSection() {
  return (
    <PageSection titleId={TitleId} tone="pad">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-start lg:gap-12">
        <FormCard className="lg:col-span-7">
          <ContactForm titleId={TitleId} />
        </FormCard>
        <aside className="space-y-6 lg:col-span-5">
          <ContactDetailsCard />
          <ProjectPromptCard />
        </aside>
      </div>
    </PageSection>
  );
}